import React, {Component} from 'react'
import _ from 'lodash'
// IMPORT OWN COMPONENT
import PopUp from '../../PopUpNotification/PopUp'
// IMPORT REACT TOOLBOX COMPONENTS
import Button from "react-toolbox/lib/button/Button"
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Input from "react-toolbox/lib/input/Input"
import '../../../../assets/react-toolbox/theme.css';
import theme from '../../../../assets/react-toolbox/theme.js';
import ThemeProvider from 'react-toolbox/lib/ThemeProvider';
import IconButton from "react-toolbox/lib/button/IconButton"
import List from 'react-toolbox/lib/list/List'
import ListItem from 'react-toolbox/lib/list/ListItem'
//KEYSTONE API
import "./createUserForm.css"

import {Redirect, Link, withRouter} from "react-router-dom";

// REDUX IMPORTS
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as manageUserActions from '../../../../actions/manageUsers';
import * as orgActions from '../../../../actions/organizations';

class AddUserForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user ? {
                id: props.user.id,
                name: props.user.username,
                email: props.user.email,
                password: '',
                role: props.user.admin ? 'admin' : 'basic',
                organizations: props.organizations ? props.organizations.filter(org => {
                    return _.includes(org.users.map(user => {
                        return user.user_id
                    }), props.user.id)
                }).map(org => {
                    return {
                        id: org.id,
                        name: org.name,
                        isAdmin: org.users.find(user => {
                            return user.user_id === props.user.id
                        }).isAdmin
                    }
                }) : []
            } : {
                id: '',
                name: '',
                email: '',
                password: '',
                role: 'basic',
                organizations: []
            },
            passwordErr: false,
            emailErr: false,
            create: true,
            redirect: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps) {
        let newState = this.state;

        if ((prevProps.user !== this.props.user || prevProps.organizations !== this.props.organizations) && this.props.user) {
            newState.user = {
                id: this.props.user.id,
                name: this.props.user.username,
                email: this.props.user.email,
                password: '',
                role: this.props.user.admin ? 'admin' : 'basic',
                organizations: this.props.organizations ? this.props.organizations.filter(org => {
                    return _.includes(org.users.map(user => {
                        return user.user_id
                    }), this.props.user.id)
                }).map(org => {
                    return {
                        id: org.id,
                        name: org.name,
                        isAdmin: org.users.find(user => {
                            return user.user_id === this.props.user.id
                        }).isAdmin
                    }
                }) : []
            };

            this.setState(newState);
        }

    }

    handleChange(name, value) {
        let newState = this.state;
        newState.user[name] = name === 'role' ? value.target.value : value;
        this.setState(newState);
    };

    handleSubmit() {
        if (this.props.create) {
        }
        let re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        let emailErr = re.test(String(this.state.user.email).toLowerCase());

        let passwordErr = this.state.user.password.length < 6 && this.props.isNew;

        if (emailErr && !passwordErr) {
            if (this.props.isNew) {
                let body = {
                    email: this.state.user.email,
                    username: this.state.user.name,
                    password: this.state.user.password,
                    admin: this.state.user.role === 'admin'
                };
                if (this.props.organization)
                    this.props.manageUserActions.createUserOrganization(body, this.props.organization, (err) => {
                        if(!err)
                            this.setState({...this.state, redirect: true});
                    });
                else
                    this.props.manageUserActions.createUser(body, (err) => {
                        if(!err)
                            this.setState({...this.state, redirect: true});
                    });
            } else
                this.props.manageUserActions.updateUser({
                    email: this.state.user.email,
                    username: this.state.user.name,
                    admin: this.state.user.role === 'admin'
                }, this.state.user.id, false, null);
            this.setState({
                ...this.state,
                passwordErr: false,
                emailErr: false,
                roleErr: false,
                redirect: true
            });
        } else {
            this.setState({
                ...this.state,
                passwordErr,
                emailErr: !emailErr,
            });
        }
    };

    handleKey(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleSubmit();
        }

    }

    handleOrgs() {

        return this.state.user.organizations.map((org, key) => {
            return (
                <ListItem
                    key={key}
                    caption={org.isAdmin ? `${org.name} - Admin` : org.name}
                    rightActions={[
                        <Link to={"/admin/organizations/detail/" + org.id} key={key}>
                            <IconButton
                                key={`inf_${key}`}
                                icon='info'
                                primary
                            /></Link>
                    ]}
                />
            );
        });
    }

    render() {
        if (this.state.redirect)
            return (
                <Redirect push to={this.props.admin ? '/admin/organizations' : '/organization'}/>
            );
        else
            return (
                <ThemeProvider theme={theme}>
                    <div className="col-xs-12">
                        {/*<PopUp active={this.props.popUp.activePopUp} type="User"*/}
                        {/*handlePopUp={this.props.manageUserActions.handlePopUp}*/}
                        {/*title={this.props.popUp.title} popUpMSG={this.props.popUp.popUpMSG}/>*/}
                        <div className="addUserFormContainer">
                            <h3 className="formHeader">{this.props.isNew ? 'User Creation Form' : 'User Info'}</h3>
                            <Link to={this.props.admin ? '/admin/organizations' : '/'}><IconButton primary
                                                                                                   className="buttonClose"
                                                                                                   icon="close"
                            /></Link>
                            <form className={'addUserForm'} onKeyDown={this.handleKey.bind(this)}>

                                <Input className="inputForm" required type="text" label="Email" name="email"
                                       value={this.state.user.email}
                                       onChange={this.handleChange.bind(this, "email")}/>
                                {this.state.emailErr && <p style={{color: 'red'}}> Please introduce a valid email.</p>}

                                <Input className="inputForm" required type="text" label="Name" name="name"
                                       value={this.state.user.name}
                                       onChange={this.handleChange.bind(this, "name")}/>

                                <Input className="inputForm" required type="password" label="Password" name="pswrd"
                                       value={this.state.user.password}
                                       disabled={!this.props.isNew}
                                       onChange={this.handleChange.bind(this, "password")}/>
                                {this.state.passwordErr &&
                                <p style={{color: 'red'}}> Please introduce a valid password. Min length 6
                                    characters. </p>}

                                <Select
                                    value={this.state.user.role}
                                    onChange={this.handleChange.bind(this, 'role')}
                                    name="role"
                                >
                                    <MenuItem value={'admin'}>Admin</MenuItem>
                                    <MenuItem value={'basic'}>Basic</MenuItem>
                                </Select>


                                {this.state.roleErr && <p style={{color: 'red'}}> Please introduce a valid role.</p>}

                                {!this.props.isNew && <div>
                                    <h4 className="usersHeader">Organizations</h4>
                                    <List>
                                        {this.handleOrgs()}
                                    </List>
                                </div>}

                                <Button className="inputForm" accent raised label="Submit"
                                        onClick={this.handleSubmit}/>
                            </form>
                        </div>
                    </div>
                </ThemeProvider>
            )
    }
}

const stateToProps = (state, props) => {
    if (state.user.admin)
        return {
            admin: true,
            user: state.organizations.userslist.find(element => element.id === props.match.params.id),
            organizations: state.organizations.organizationsList,
            isNew: props.match.params.id === 'new',
        };
    else
        return {
            admin: false,
            isNew: true,
            organization: props.match.params.id
        }
};

const dispatchToProps = (dispatch) => {
    return {
        manageUserActions: bindActionCreators(manageUserActions, dispatch),
        organizationsActions: bindActionCreators(orgActions, dispatch),
    }
};

export default withRouter(connect(stateToProps, dispatchToProps)(AddUserForm))



// WEBPACK FOOTER //
// ./src/components/DashBoard/AdminOrganizations/CreateUser/createUserForm.js